import axios from 'axios'

const API_BASE = 'https://api.psro.net/api/admin'

export interface AdminSettings {
  window_minutes: number
  max_failures: number
  lockout_minutes: number
}

export interface ActivityLog {
  id: number
  user_id: number | null
  username: string
  ip_address: string
  action: string
  message: string
  created_at: string
}

export interface ActivityLogsResponse {
  logs: ActivityLog[]
  total: number
}

export interface UserListItem {
  id: number
  username: string
  nickname: string
  email: string
  role: 'sysadmin' | 'group_admin' | 'user'
}

export interface UsersListResponse {
  users: UserListItem[]
}

export const getAdminSettings = async (): Promise<{ success: boolean; data?: AdminSettings; error?: string }> => {
  try {
    const response = await axios.get(`${API_BASE}/settings`, {
      withCredentials: true,
    })
    return response.data
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      return error.response.data
    }
    return {
      success: false,
      error: '無法連接到伺服器',
    }
  }
}

export const updateAdminSettings = async (
  settings: Partial<AdminSettings>
): Promise<{ success: boolean; error?: string }> => {
  try {
    const response = await axios.put(`${API_BASE}/settings`, settings, {
      withCredentials: true,
    })
    return response.data
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      return error.response.data
    }
    return {
      success: false,
      error: '無法連接到伺服器',
    }
  }
}

export const getActivityLogs = async (
  { search = '', page = 1, limit = 50 } = {}
): Promise<{ success: boolean; data?: ActivityLogsResponse; error?: string }> => {
  try {
    const params = new URLSearchParams()
    if (search) params.append('search', search)
    params.append('page', String(page))
    params.append('limit', String(limit))

    const response = await axios.get(`${API_BASE}/activity-logs?${params.toString()}`, {
      withCredentials: true,
    })
    return response.data
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      return error.response.data
    }
    return {
      success: false,
      error: '無法連接到伺服器',
    }
  }
}

export const exportActivityLogs = async (): Promise<Blob> => {
  const response = await axios.get(`${API_BASE}/activity-logs/export`, {
    withCredentials: true,
    responseType: 'blob',
  })
  return response.data
}

export const getUsers = async (): Promise<{ success: boolean; data?: UsersListResponse; error?: string }> => {
  try {
    const response = await axios.get(`${API_BASE}/users`, {
      withCredentials: true,
    })
    return response.data
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      return error.response.data
    }
    return {
      success: false,
      error: '無法連接到伺服器',
    }
  }
}

export const updateUserRole = async (
  userId: number,
  role: string
): Promise<{ success: boolean; error?: string }> => {
  try {
    const response = await axios.put(`${API_BASE}/users/${userId}/role`, { role }, {
      withCredentials: true,
    })
    return response.data
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      return error.response.data
    }
    return {
      success: false,
      error: '無法連接到伺服器',
    }
  }
}
